import axios from 'axios';
import {useQuery} from '@tanstack/react-query';

import {authAtom} from 'store';
import {useSetRecoilState} from 'recoil';

import {onUserRes} from './helper';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

const user = async () => axios.get(Routes.USER);

export const useUser = () => {
  const setAuth = useSetRecoilState(authAtom);

  return useQuery({
    queryKey: [Keys.USER_QRY],
    queryFn: user,
    onSuccess: res => onUserRes({auth: res.data, setAuth}),
    enabled: false,
    retry: false,
  });
};
